module.exports = __webpack_public_path__ + "static/media/mdi_vertical_align_center.32aacb0d.svg";